import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';

interface SearchContentsCardProps {
  imageSrc?: string;
  title?: string;
  content?: string;
  daysAgo?: string;
  link?: string;
}

export const SearchContentsCard = ({
  imageSrc,
  title,
  content,
  daysAgo,
  link = '#',
}: SearchContentsCardProps) => {
  return (
    <CustomLink
      href={link}
      className="flex flex-col gap-8 rounded-medium border border-Gray-100 bg-Gray-white px-24 py-20 transition-colors hover:bg-Gray-25 mobile-tablet:gap-12 mobile-tablet:rounded-none mobile-tablet:border-0"
    >
      <div className="flex items-start gap-24">
        <div className="flex min-w-0 flex-1 flex-col gap-8 mobile-tablet:gap-12">
          {title ? (
            <h3 className="line-clamp-1 break-all font-600 text-Gray-black typo-body3 mobile-tablet:line-clamp-2 mobile-tablet:typo-body4">
              {title}
            </h3>
          ) : null}
          {content ? (
            <p className="line-clamp-2 break-all font-400 text-Gray-600 typo-body4 mobile-tablet:typo-caption1">
              {content}
            </p>
          ) : null}
          {daysAgo ? (
            <p className="font-400 text-Gray-550 typo-caption1">{daysAgo}</p>
          ) : null}
        </div>
        {imageSrc ? (
          <Image
            alt="thumbnail"
            className="aspect-square shrink-0 rounded-small border-1 border-Gray-100 object-cover mobile-tablet:size-68 mobile-tablet:self-center"
            height={96}
            src={imageSrc}
            width={96}
          />
        ) : null}
      </div>
    </CustomLink>
  );
};
